module.exports = __webpack_public_path__ + "media/2.61d00625.mp3";